// The Rulebook — single source of truth for how VoluntoldHQ works.
// Edit copy here; the /rulebook page, "What's this?" links, and search all read from this.
export const RULES = [
  {
    number: "01",
    slug: "the-sideline",
    name: "The Sideline",
    description:
      "A weekly note from Coach Kyto: one real story, one coaching tool, one mental rep.",
    where: "Email · Weekly",
    link: "/#the-sideline",
    cta: "JOIN THE SIDELINE →",
  },
  {
    number: "02",
    slug: "time-out",
    name: "Time Out",
    description:
      "We stop the play. One topic, broken down so coaches and parents both walk away with something.",
    where: "Video",
    link: "/series/time-out",
    cta: "SEE THE SERIES →",
  },
  {
    number: "03",
    slug: "penalty",
    name: "Penalty",
    description:
      "Sideline behavior, officially called. Yelling from the stands, comparing kids, coaching from the bleachers — flag on the play.",
    where: "Video",
    link: "/series/penalty",
    cta: "SEE THE SERIES →",
  },
  {
    number: "04",
    slug: "instant-replay",
    name: "Instant Replay",
    description: "We rewind a real moment and break it down in slow motion.",
    where: "Video",
    link: "/series/instant-replay",
    cta: "SEE THE SERIES →",
  },
  {
    number: "05",
    slug: "crossed-signals",
    name: "Crossed Signals",
    description:
      "What the coach says vs. what the player hears. Same words, different game.",
    where: "Video",
    link: "/series/crossed-signals",
    cta: "SEE THE SERIES →",
  },
  {
    number: "06",
    slug: "micd-up",
    name: "Mic'd Up",
    description: "Coach Kyto, straight to camera. One lesson, no cuts.",
    where: "Video",
    link: "/series/micd-up",
    cta: "SEE THE SERIES →",
  },
  {
    number: "07",
    slug: "hot-take-huddle",
    name: "Hot Take Huddle",
    description:
      "One debate. Two sides. You vote. Coach Kyto's take lands in The Sideline.",
    where: "Site + Instagram",
    link: "/#hot-take-huddle",
    cta: "VOTE NOW →",
  },
  {
    number: "08",
    slug: "after-the-whistle",
    name: "After the Whistle",
    description:
      "Real talk on life, coaching, parenting, and the moments after the game — including \u201cI Used to Be That Kid\u201d stories.",
    where: "Read + Watch",
    link: "/series/after-the-whistle",
    cta: "SEE THE SERIES →",
  },
  {
    number: "09",
    slug: "the-mental-rep",
    name: "The Mental Rep",
    description:
      "Mindset, pressure, confidence — the mental side of the game.",
    where: "Read + Watch",
    link: "/series/the-mental-rep",
    cta: "SEE THE SERIES →",
  },
];

export const ruleBySlug = (slug) => RULES.find((r) => r.slug === slug) || null;
